import { LinkCard } from '@/components/elements/LinkCard'
import { LinkCardList } from '@/components/elements/LinkCardList'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'

export const More = () => {
  return (
    <div>
      <SectionTitle titleText="Other Contents" subTitleText="" color="normal" />
      <Spacer h={{ sp: 40, pc: 70 }} />
      <LinkCardList>
       
        <LinkCard
          title="Video Libraly"
          link="/en/news/video/"
          imgPath="/images/news-video-library.svg"
        />
       
      </LinkCardList>
    </div>
  )
}
